import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import ChartCustomTooltip from "../../common-components/chart-custom-tooltip/chart-custom-tooltip";
import { chartColors } from "../../clients-dashboard-style";
import { getInsurancePremiumPortfolioChartData } from "./helpers";
import { CustomTooltipProps, TicksProps } from "../../clients-dashboard-types";
import { IGetInsurancePremiumPortfolioData } from "../../../../../services/ClientsDashboardServices.dto";

const InsurancePremiumPortfolioChart = ({ data }: { data: IGetInsurancePremiumPortfolioData }) => {
  const [hiddenSeries, setHiddenSeries] = React.useState<Array<string>>([]);

  const newData = getInsurancePremiumPortfolioChartData(data);
  const productTypes = Object.keys(newData[0]);

  const handleLegendClick = (dataKey: string) => {
    // Desactiva y activa las barras de los productos seleccionados
    if (hiddenSeries.includes(dataKey)) {
      setHiddenSeries(hiddenSeries.filter((el) => !el.includes(dataKey)));
    } else {
      setHiddenSeries((prev) => [...prev, dataKey]);
    }
  };

  const renderCustomTick = (tickProps: TicksProps) => {
    const { x, y, index } = tickProps;
    // Se busca la primera aparición de un año para mostrarlo una sóla vez
    const isYearChange = index === 0 || newData[index].year !== newData[index - 1].year;

    return (
      <g transform={`translate(${x},${y})`}>
        {isYearChange && (
          <text x={0} y={0} dy={40} textAnchor="middle" fill="#666" fontSize={20}>
            {newData[index].year}
          </text>
        )}
        <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
          {newData[index].month}
        </text>
      </g>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={800}>
      <BarChart
        width={500}
        height={300}
        data={newData}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="month" height={70} tick={renderCustomTick} />
        <XAxis dataKey="year" xAxisId={1} hide />
        <YAxis />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip content={(props: CustomTooltipProps) => <ChartCustomTooltip {...props} />} />
        <Legend iconType="circle" onClick={(props) => handleLegendClick(props.dataKey)} />
        {productTypes.map((type: string, index) => {
          if (type === "month" || type === "year") return null;
          return (
            <Bar
              key={type}
              dataKey={type}
              fill={chartColors[index]}
              hide={hiddenSeries.includes(type)}
            />
          );
        })}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default InsurancePremiumPortfolioChart;
